export default __webpack_public_path__ + "static/media/bg_contact_mobile.2525b81e.svg";